<template>
  <div onselectstart="return false" style="-moz-user-select: none">
    <router-view />
  </div>
</template>
<script>
export default {
  name: "index",
  data() {
    return {};
  },
  methods: {}
};
</script>
<style>
.el-table thead tr th.el-table__cell {
  background-color: #329ffe;
  color: white;
}
.middle .rt .title {
  height: 48px;
  background: #329ffe;
  font-size: 16px;
  line-height: 48px;
  padding-left: 24px;
  color: #ffffff;
}
.middle .rt .rtContent .money .btn > div span {
  font-size: 14px;
  display: block;
}
.middle .rt .rtContent .money .btn > div {
  padding-top: 42px;
  margin-top: 6px;
  width: 54px;
  height: 128px;
  background: #feaf32;
  border-radius: 5px;
  font-size: 18px;
  color: #fff;
  text-align: center;
  cursor: pointer;
}
.middle .rt .rtContent .money .btn .qx {
  color: #707070;
  background: #e3e5e9;
  margin-top: 4px;
}
.middle .rt .rtContent .money .btn {
  width: 54px;
  margin-left: auto;
  margin-right: 7px;
}
.middle .rt .rtContent .money ul li p span {
  color: #ff0000;
  margin-right: 20px;
  display: inline-block;
}
.middle .rt .rtContent .money ul li input {
  width: 200px;
  height: 49px;
  font-size: 0.10417rem;
  color: #ff0000;
  margin-right: 20px;
  text-align: right;
  background: #ffffff;
  border: 1px solid #000000;
  border-radius: 5px;
}
.middle .rt .rtContent .money ul li {
  width: 343px;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.middle .rt .rtContent .money {
  padding-left: 42px;
  display: flex;
  width: 100%;
}
.middle .rt .rtContent .way .payWay > p {
  font-size: 14px;
  color: #000000;
  width: 50%;
  text-align: center;
  margin-top: 6px;
}
.middle .rt .rtContent .way .payWay .el-radio-group {
  width: 50%;
}
.middle .rt .rtContent .way .payWay .rad {
  width: 50%;
}
.middle .rt .rtContent .way .payWay .el-radio {
  width: 100%;
  font-size: 14px;
  margin-bottom: 10px;
}
.middle .rt .rtContent .way .payWay {
  display: flex;
  align-items: flex-start;
  width: 325px;
  margin-top: 36px;
}
.middle .rt .rtContent .way {
  width: 325px;
  height: 100%;
  border-right: 1px solid #f1f3f7;
}
.middle .rt .rtContent {
  display: flex;
  width: 100%;
  height: 100%;
}
.middle .rt {
  width: 854px;
  height: 320px;
  background: #ffffff;
  border-radius: 5px 5px 0px 0px;
  overflow: hidden;
  margin-left: 15px;
}
.middle .lt .title {
  height: 48px;
  background: #329ffe;
  font-size: 16px;
  line-height: 48px;
  padding-left: 24px;
  color: #ffffff;
}
.middle .lt .userinfo li {
  margin-bottom: 19px;
}
.middle .lt .userinfo li:last-child {
  display: flex;
}
.middle .lt .userinfo label {
  font-size: 14px;
  color: #000000;
  width: 56px;
  text-align: justify;
  display: inline-block;
  text-justify: distribute-all-lines;
  text-align-last: justify;
}
.middle .lt .userinfo input {
  font-size: 14px;
  margin-left: 18px;
  width: 335px;
  padding-left: 20px;
  height: 41px;
  background: #ffffff;
  border: 1px solid #000000;
  border-radius: 5px;
}
.middle .lt .userinfo textarea {
  margin-left: 18px;
  width: 335px;
  padding-left: 20px;
  background: #ffffff;
  border: 1px solid #000000;
  border-radius: 5px;
}
.middle .lt .userinfo {
  margin-top: 31px;
}
.middle .lt {
  width: 540px;
  height: 320px;
  background: #ffffff;
  border-radius: 5px 5px 0px 0px;
  overflow: hidden;
}
.middle {
  display: flex;
  margin-top: 19px;
}
.is_cardNun .isc_btn.orange {
  background: #feaf32;
}
.is_cardNun .isc_btn {
  width: 80px;
  height: 34px;
  background: #329ffe;
  border-radius: 5px;
  margin-right: 32px;
  line-height: 34px;
  text-align: center;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #ffffff;
}
.is_cardNun .sta {
  color: #0c995f;
}
.is_cardNun input::placeholder {
  color: #000000;
}
.is_cardNun input {
  margin: 0 30px 0 19px;
  width: 201px;
  height: 35px;
  background: #ffffff;
  border: 1px solid #000000;
  border-radius: 5px;
  padding-left: 28px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #101010;
}
.is_cardNun::placeholder {
  color: #000000;
}
input::placeholder{
  color: #333333!important;
}
.is_cardNun {
  margin-bottom: 34px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #101010;
}

.info_sure_pop .btn_out {
  height: 75px;
  background: #f7f7f7;
  width: 100%;
}
.info_sure_pop table td {
  padding-top: 20px;
  word-break: break-all;
}
.info_sure_pop table {
  table-layout: fixed;
  width: 100%;
}
.info_sure_pop .isp_card {
  padding: 5px 30px 20px;
  border: 1px solid #000000;
  margin-top: 25px;
}
.info_sure_pop .isp_label span {
  color: #ff0000;
}
.info_sure_pop .isp_label {
  font-size: 16px;
}
.info_sure_pop .isp_content {
  padding: 20px 45px 12px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #101010;
  background-color: #ffffff;
}
.info_sure_pop .isp_title img {
  width: 22px;
  height: 23px;
}
.info_sure_pop .isp_title {
  height: 47px;
  background: #329ffe;
  line-height: 47px;
  padding: 0 24px;
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #f7f7f7;
}
.info_sure_pop .info_sure {
  width: 1000px;
  background: #ffffff;
  border-radius: 0px 0px 5px 5px;
  overflow: hidden;
}
.info_sure_pop {
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.75);
  height: 100%;
  width: 100%;
  position: fixed;
  z-index: 1000;
  overflow: hidden;
}

.btn_out div.grey {
  color: #707070;
  margin-left: 80px;
  background-color: #e3e5e9;
}
.btn_out div {
  width: 168px;
  height: 54px;
  background: #feaf32;
  border-radius: 5px;
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
}

.tm_pop .el-dialog {
  position: relative;
  width: 680px;
  height: 450px;
  border-radius: 5px 5px 0px 0px;
}
.tm_pop .el-dialog__header {
  display: none;
}
.tm_pop .el-dialog__body {
  padding: 0;
}
.ec_out .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #fff;
}
.ec_out .el-checkbox__inner {
  height: 20px;
  width: 20px;
}
.ec_out.el-checkbox__input.is-checked .el-checkbox__inner,
.ec_out .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #fff !important;
}
.ec_out .el-checkbox__inner::after {
  top: 3px;
  left: 6px;
  border: 2px solid #000;
  border-left: 0;
  border-top: 0;
}
.ec_out .el-radio__label {
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #101010;
}

.ec_out .el-radio__input.is-checked + .el-radio__label {
  color: #000;
}

.ec_out .el-table__header .el-table-column--selection .cell .el-checkbox:after {
  color: #fff;
  content: "全选";
  fontfamily: "Source Han Sans CN";
  fontweight: 400;
  margin-left: 12px;
  margin-top: 3px;
  font-size: 16px;
}

.ec_out .el-table .el-table__inner-wrapper::before {
  background-color: #fff;
}
.ec_out .el-table .el-table__cell {
  border: none;
}

.ca_pop .el-dialog {
  position: relative;
  width: 680px;
  height: 420px;
  border-radius: 14px;
}
.ca_pop .el-dialog__header {
  display: none;
}
.ca_pop .el-dialog__body {
  padding: 0;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.ca_pop .el-dialog__body img {
  width: 82px;
  height: 82px;
}
.ca_pop .el-dialog__body .dialogText {
  font-size: 24px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #3e3e3e;
  text-align: center;
}
.ca_pop .el-dialog__body .successText {
  font-size: 36px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #3e3e3e;
  text-align: center;
}
.ca_pop .el-dialog__body .noticeText {
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #3e3e3e;
  text-align: center;
}
.ca_pop .el-dialog__body .dialog-footer {
  display: flex;
  justify-content: center;
  align-items: center;
}
.ca_pop .el-dialog__body .dialog-footer button:first-child {
  outline: none;
  border: none;
  width: 120px;
  height: 40px;
  background: #e7752a;
  border-radius: 5px;
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
  margin-right: 40px;
}
.ca_pop .el-dialog__body .dialog-footer button:last-child {
  outline: none;
  border: none;
  width: 120px;
  height: 40px;
  background: #a6a6a6;
  border-radius: 5px;
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
}
.etm_pop .form {
  margin-left: 17%;
}
.etm_pop .form .el-input {
  width: 281px;
  height: 35px;
}
.etm_pop .form .el-form-item {
  margin-bottom: 20px;
}
.etm_pop .el-dialog {
  position: relative;
  width: 680px;
  height: 420px;
  border-radius: 5px 5px 0px 0px;
}
.etm_pop .el-dialog__header {
  display: none;
}
.etm_pop .el-dialog__body {
  padding: 0;
}
.etm_pop .dialog .button {
  position: absolute;
  bottom: 0;
  display: flex;
  width: 680px;
  height: 104px;
  background: #f7f7f7;
}
.etm_pop .dialog .button .el-button {
  width: 168px;
  height: 54px;
  font-size: 24px;
  border-radius: 5px;
  border: none;
  margin-top: 25px;
}
.etm_pop .dialog .button .el-button:nth-child(1) {
  margin-left: 132px;
  margin-right: 80px;
}
.etm_pop .dialog h6 {
  padding-left: 24px;
  line-height: 47px;
  height: 47px;
  background: #329ffe;
  border-radius: 5px 5px 0px 0px;
  font-size: 16px;
  color: #ffffff;
}
.ec_out .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #fff;
}
.eb_out .el-checkbox__inner {
  height: 20px;
  width: 20px;
}

.eb_out .el-checkbox__inner::after {
  top: 3px;
  left: 6px;
  border: 2px solid #000; /*// 是改这里的颜色*/
  border-left: 0;
  border-top: 0;
}
.eb_out .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #fff;
}
.el-table{
  color: #000000!important;
}
.el-radio__inner,.el-checkbox__inner,.el-input__inner{
  border-color: #000000!important;
}
.el-radio__input.is-checked .el-radio__inner{
  border-color: #409EFF!important;
}
.create-isLoading .el-loading-text{
  font-size: 48px;
}
.create-isLoading i{
  font-size: 48px;

}
.bottombar{
  margin-top: 20px;
}
.paging .pagingText {
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #4e4e4e;
    margin-right: 17px;
}

.paging .pagingInput {
    width: 30px;
    height: 30px;
    margin: 0 10px;
}

.paging .pagingButton {
    width: 80px;
    height: 30px;
    background: #329ffe;
    border-radius: 5px;
    border: none;
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #fefefe;
}

/*// 分页区域样式*/
.paging {
    margin-right: 50px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue